import { InflatedListItemProduct } from './ListTypes'
import SquareContainer from '../components/SquareContainer'
import ConfigurableProductView from '../components/ConfigurableProductView'
import { getDefaultSkinOrientation } from '../products/productUtils'
import { getSkinErrorImage, getSkinPlaceholderImage } from '../data/test-data'
import ConfigurableProductButton from '../components/ConfigurableProductButton'
import React from 'react'

export default function ListItemProductPreview(props: { configuredProduct: InflatedListItemProduct, size: string }) {
  const { configuredProduct, size } = props
  return (
    <SquareContainer size={size}>
      <ConfigurableProductView
        shadowScale={0.2}
        {...configuredProduct.skinProduct}
        orientation={configuredProduct.skinProduct.orientation}
        buttonCoordsOrientation={getDefaultSkinOrientation(configuredProduct.skinProduct)}
        image={configuredProduct.skinProduct.image}
        placeholderImage={getSkinPlaceholderImage(configuredProduct.skinProduct, configuredProduct.skinProduct.gridProduct)}
        errorImage={getSkinErrorImage(configuredProduct.skinProduct, configuredProduct.skinProduct.gridProduct)}
        renderButton={(props, buttonIndex, scale, shadowScale) => {
          const { interfaceProduct, mechProduct } = configuredProduct.configuredButtons[buttonIndex]
          return (
            <ConfigurableProductButton
              baseScale={scale}
              shadowScale={shadowScale}
              {...props}
              backgroundImage={mechProduct?.image}
              foregroundImage={interfaceProduct.image}
              debugColorCode={interfaceProduct.color}
            />
          )
        }}
      />
    </SquareContainer>
  )
}
